export default __webpack_public_path__ + "static/media/product-5-1.16eba1c0.jpg";